import { component } from "preact";
import { css } from "emotion";

const icBlockquote = require("../../assets/ic_blockquote.svg");
import { getSize } from "../../utils/BrowserUtils";

const Blockquote = ({
  color = "#323232",
  marginTop = 0,
  marginBottom = 0,
  breakpoint = 600,
  marginBottomMobile = 0,
  marginTopMobile = 0,
  maxWidth = "none",
  mobileMaxWidth = "none",
  children
}) => {
  const styleObj = {
    position: "relative",
    fontSize: 20,
    color: color,
    marginTop: marginTop,
    marginBottom: marginBottom,
    maxWidth: maxWidth,
    marginLeft: maxWidth === "auto" ? 0 : "auto",
    marginRight: maxWidth === "auto" ? 0 : "auto"
  };

  styleObj[`@media(max-width:${breakpoint}px)`] = {
    fontSize: 16,
    marginTop: marginTopMobile,
    marginBottom: marginBottomMobile
  };
  const style = css(styleObj);

  const beforeQuote = css({
    width: 20,
    height: 26,
    backgroundImage: `url(${icBlockquote})`,
    backgroundRepeat: `no-repeat`,
    content: '""',
    display: "inline-block",
    "@media(max-width: 414px)": {
      display: "none"
    }
  });

  const afterQuote = css({
    width: 20,
    height: 11,
    backgroundImage: `url(${icBlockquote})`,
    transform: `rotate(180deg)`,
    content: '""',
    display: "inline-block",
    verticalAlign: "bottom",
    "@media(max-width: 414px)": {
      display: "none"
    }
  });

  const size = getSize();

  return (
    <blockquote className={style}>
      <span className={beforeQuote} />
      {size.innerWidth < 600 ? '"' : ""}
      {children}
      {size.innerWidth < 600 ? '"' : ""}
      <span className={afterQuote} />
    </blockquote>
  );
};

export default Blockquote;
